import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-marquee';

const html = `
<div class="wrap-card">
  <div data-show="true" data-attribute="card-title" class="card-title" style="display: block;">
    <h2 style="text-align: center;">Over 565K+ Happy Customers</h2>
    <p style="text-align: center;">
      Designed to shape, support, and move with your body-helping women feel more confident, comfortable, and empowered
      every day.
    </p>
  </div>
  <div
    data-speed="25"
    data-item-gap="20"
    data-item-width="270"
    data-attribute="block-marquee"
    class="block-marquee"
    style=" --speed: 25s; --item-width: 270px; --item-gap: 20px;"
  >
    <div data-attribute="list-item" class="list-item">
      <div data-attribute="item" class="item-marquee">
        <div data-attribute="link-item" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f1c800917f3a48d215f8.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-attribute="item" class="item-marquee">
        <div data-attribute="link-item" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f1cb5f17be82b54ab8c6.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-attribute="item" class="item-marquee">
        <div data-attribute="link-item" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f1d02a02e3a0ea0bf502.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-attribute="item" class="item-marquee">
        <div data-attribute="link-item" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f1d493cff0d940185e16.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-attribute="item" class="item-marquee">
        <div data-attribute="link-item" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f1d70645840a4844b72c.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-attribute="item" class="item-marquee">
        <div data-attribute="link-item" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f1da98a532ec66bd7fae.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-attribute="item" class="item-marquee">
        <div data-attribute="link-item" class="wrap-item">
          <div class="wrap-img">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f1dd7b2183ead1086b56.gif"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
